const tooltipMatTableOver = {
  delete: 'Delete',
  edit: 'Edit',
  true: 'Save',
  false: 'Delete',
  cancel: 'Cancel',
  add: 'Add'
};

export default tooltipMatTableOver;
